import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const items = ["Logos", "Websites", "Flyers", "Brochures", "Print", "Digital"];

export const MarqueeRibbon = () => (
  <div className="border-y border-border py-6 md:py-8 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {items.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-syne font-semibold uppercase text-2xl md:text-4xl tracking-tight text-muted-foreground mx-10 md:mx-16">
            {item}
          </span>
          <Asterisk className="text-primary" size={28} />
        </span>
      ))}
    </Marquee>
  </div>
);
